export const Message = ({ message }: { message: string }) => (
  <div style={{ textAlign: 'center', margin: '20px', color: '#b6bcc8' }}>{message}</div>
);
